function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useCallback } from 'react';
import { useIntl as useReactIntl } from 'react-intl';
export var useIntl = () => {
  var intl = useReactIntl();
  var {
    timeZone,
    locale
  } = intl;
  var formatCurrency = useCallback(function (amount) {
    var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
    var options = arguments.length > 2 ? arguments[2] : undefined;
    return intl.formatNumber(amount, _objectSpread(_objectSpread({}, options), {}, {
      style: 'currency',
      currency
    }));
  }, [intl]);
  var formatDate = intl.formatDate.bind(intl);
  var formatDateTimeRange = intl.formatDateTimeRange.bind(intl);
  var formatNumberToParts = intl.formatNumberToParts.bind(intl);
  return {
    locale,
    timeZone: timeZone,
    formatCurrency,
    formatDate,
    formatDateTimeRange,
    formatNumberToParts
  };
};
//# sourceMappingURL=useIntl.js.map